/**
 * Data loading and utility functions
 */

// import questionsData from '../questions.json';
import { AppBook, AppChapter, AppQuestion, Books } from './types';
import allBooks from './books';

// Re-export types for backward compatibility
export type { AppBook, AppChapter, AppQuestion, Books };

// Export the books data
export { allBooks };


export function getBookData(): AppBook {
  const books = allBooks;

  for (const book of books.books) {
    if (book.book_id === "9780879397241") {
      return book
    }
  }
  return books.books[1];
}